export default API => ({
    // 订单页面获取订单详情
      getOrderByNo(id) {
          return API({
              url: `/order/v1/open/order/getOrderByNo?orderNo=${id}`,
          });
      },
      // 查询订单状态
      getOrderStatus(id) {
          return API({
              url: `/order/v1/open/order/getOrderStatus?orderNo=${id}`,
          });
      },
      // 取消订单
      cancelOrder(id) {
            return API({
                url: `/order/v1/open/order/mall/cancelOrder?orderNo=${id}`,
                method:'post'
            });
        },
      // 跳转到支付存储相关数据
        jumpPaySaveParams(data) {
            return API({
                url:`/pay/wechat/cache/put`,
                method:'post',
                data
            });
        },
        // /account/register2Branch
        register2Branch({data}) {
            return API({ 
                url: `/usercenter/v1/account/register2Branch`,
                data,
                method: 'post'
            }); 
    
        }
  })